import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import { Component, Prop, Ref, Vue } from "vue-facing-decorator";
import QuizViewerLayout from "@/components/layout/QuizViewerLayout.vue";
import QuizViewerCarousel from "@/components/quiz/QuizViewerCarousel.vue";
import QuizPreamble from "@/components/quiz/QuizPreamble.vue";
import InformationDialog from "@/components/dialogs/NotificationDialog.vue";
import SimpleQuiz from "@/components/quiz/SimpleQuiz.vue";
import ChapterWideScreenMsg from "@/components/chapter/ChapterWideScreenMsg.vue";
import { shuffle } from 'lodash';
import { Events } from "@/events/events";
import QuizUtils from "@/util/quizUtils";
let SimpleQuizPlayer = class SimpleQuizPlayer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quizJsonString", void 0);
    _defineProperty(this, "isLastChapter", void 0);
    _defineProperty(this, "isLocked", void 0);
    _defineProperty(this, "simpleQuizViewerCarousel", void 0);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "displayableQuestions", []);
    _defineProperty(this, "currentQuestionIndex", 0);
    _defineProperty(this, "quizCompleted", false);
    _defineProperty(this, "realtimeUserAnswers", null);
    _defineProperty(this, "correctAnswersIds", []);
    _defineProperty(this, "displayResults", false);
    _defineProperty(this, "answersApprovalState", null);
    _defineProperty(this, "displayNextQuestionButton", false);
  }
  mounted() {
    if (this.quizJsonString) {
      this.quiz = JSON.parse(this.quizJsonString);
      this.buildDisplayableQuestions();
    }
  }
  get userHasAnswered() {
    const question = this.findQuestionById(this.realtimeUserAnswers?.questionId);
    if (question) {
      if (this.realtimeUserAnswers?.responsesIds?.length) {
        return true;
      }
      if (this.realtimeUserAnswers?.blanksResponses?.length) {
        return this.realtimeUserAnswers?.blanksResponses?.every(blank => blank.textResponse?.trim()?.length || blank.responseOptionId);
      }
      if (question.matchingPairs?.length && question.matchingPairs.length === this.realtimeUserAnswers?.pairsMatching?.length) {
        return this.realtimeUserAnswers.pairsMatching.every(pm => !!pm.responseRelatedItemId);
      }
      if (question.sortingItems?.length && question.sortingItems.length === this.realtimeUserAnswers?.itemsSorting?.length) {
        return true;
      }
    }
    return false;
  }
  get shouldDisplayConfirmButton() {
    const question = this.findQuestionById(this.realtimeUserAnswers?.questionId);
    if (question) {
      if (QuizUtils.isCheckableQuestion(question.type)) {
        return !!this.correctAnswersIds?.length;
      } else {
        return this.displayResults;
      }
    }
    return false;
  }
  onSlideChange(eventData) {
    this.currentQuestionIndex = eventData.currentSlideIndex;
  }
  buildDisplayableQuestions() {
    if (this.quiz) {
      if (!this.quiz.randomMode) {
        this.displayableQuestions = this.quiz.questions || [];
      } else {
        const questions = shuffle((this.quiz?.questions || []).slice(0, this.quiz.nbChosenQuestions));
        questions.forEach((question, index) => question.order = index + 1);
        this.displayableQuestions = questions;
      }
    }
  }
  onQuizAnswerChange(userAnswers) {
    this.realtimeUserAnswers = userAnswers;
  }
  onCorrectionButtonClick() {
    const currentQuestion = this.findQuestionById(this.realtimeUserAnswers?.questionId);
    if (currentQuestion) {
      this.displayNextQuestionButton = true;
      this.answersApprovalState = null;
      if (QuizUtils.isCheckableQuestion(currentQuestion.type)) {
        this.correctAnswersIds = this.getRightAnswersIds(currentQuestion);
      } else {
        this.displayResults = true;
      }
    }
  }
  async onConfirmButtonClick() {
    if (this.quiz && this.realtimeUserAnswers) {
      const currentQuestion = this.findQuestionById(this.realtimeUserAnswers?.questionId);
      if (!currentQuestion) {
        return false;
      }
      this.answersApprovalState = this.validateUserAnswers(currentQuestion, this.realtimeUserAnswers);
      if (this.answersApprovalState) {
        if (QuizUtils.isCheckableQuestion(currentQuestion.type)) {
          this.correctAnswersIds = this.realtimeUserAnswers.responsesIds;
        } else {
          this.displayResults = true;
        }
        this.displayNextQuestionButton = true;
      }
    }
  }
  validateUserAnswers(question, userAnswers) {
    if (this.isCheckableQuestion(question)) {
      if (!userAnswers.responsesIds?.length) {
        return false;
      }
      const correctAnswersIds = this.getRightAnswersIds(question);
      return correctAnswersIds.length === userAnswers.responsesIds.length && userAnswers.responsesIds.every(id => correctAnswersIds.includes(id));
    } else if (this.isBlanksQuestion(question)) {
      return question.blanks.every(blank => QuizUtils.isBlankAnswerCorrect(blank, this.realtimeUserAnswers?.blanksResponses || []));
    } else if (this.isPairsMatchingQuestion(question)) {
      return question.matchingPairs.every(pair => QuizUtils.isPairMatchingCorrect(pair, this.realtimeUserAnswers?.pairsMatching || []));
    } else if (this.isSortingQuestion(question)) {
      return question.sortingItems.every(sortingItem => QuizUtils.isUserQuestionItemsSortingOrderValid(sortingItem, this.realtimeUserAnswers?.itemsSorting || []));
    }
    return false;
  }
  isCheckableQuestion(question) {
    return QuizUtils.isCheckableQuestion(question.type);
  }
  isBlanksQuestion(question) {
    return QuizUtils.isBlanksQuestion(question.type);
  }
  isPairsMatchingQuestion(question) {
    return QuizUtils.isPairsMatchingQuestion(question.type);
  }
  isSortingQuestion(question) {
    return QuizUtils.isSortingQuestion(question.type);
  }
  onNextStepButtonClick() {
    if (!this.lastSlideReached()) {
      this.realtimeUserAnswers = null;
      this.correctAnswersIds = null;
      this.displayResults = false;
      this.answersApprovalState = null;
      this.displayNextQuestionButton = false;
      this.moveToNextSlide();
    } else {
      this.quizCompleted = true;
      this.displayNextQuestionButton = false;
    }
  }
  onRestartButtonClick() {
    this.quizCompleted = false;
    this.buildDisplayableQuestions();
    this.simpleQuizViewerCarousel?.slideTo(0);
    this.currentQuestionIndex = 0;
    this.realtimeUserAnswers = null;
    this.correctAnswersIds = [];
    this.displayResults = false;
    this.answersApprovalState = null;
  }
  findQuestionById(questionId) {
    if (!questionId) {
      return null;
    }
    return this.quiz?.questions?.find(question => question.id === questionId) || null;
  }
  getRightAnswersIds(question) {
    return question.answers?.filter(answer => answer.rightAnswer).map(answer => answer.id) || [];
  }
  onQuizDoneButtonClick() {
    trig(this.isLocked ? Events.CONFIRM_SIMPLE_QUIZ_COMPLETION : Events.NEXT_ETAPE);
  }
  moveToNextSlide() {
    this.simpleQuizViewerCarousel?.next();
  }
  lastSlideReached() {
    return this.currentQuestionIndex >= this.displayableQuestions.length - 1;
  }
};
__decorate([Prop({
  required: true
})], SimpleQuizPlayer.prototype, "quizJsonString", void 0);
__decorate([Prop({
  default: true
})], SimpleQuizPlayer.prototype, "isLastChapter", void 0);
__decorate([Prop({
  default: false
})], SimpleQuizPlayer.prototype, "isLocked", void 0);
__decorate([Ref('simpleQuizViewerCarousel')], SimpleQuizPlayer.prototype, "simpleQuizViewerCarousel", void 0);
SimpleQuizPlayer = __decorate([Component({
  components: {
    ChapterWideScreenMsg,
    QuizPreamble,
    QuizViewerCarousel,
    QuizViewerLayout,
    InformationDialog,
    SimpleQuiz,
    Pagination,
    Navigation,
    Slide,
    Carousel,
    StandardButton
  }
})], SimpleQuizPlayer);
export default SimpleQuizPlayer;